<template>
  <VApp>
    <ThePageHeader />

    <VContent class="pa-0 container">
      <VContainer
        fluid
        class="pa-0"
      >
        <transition
          appear
          name="appear"
          mode="out-in"
        >
          <router-view />
        </transition>
      </VContainer>
    </VContent>

    <TheCookieBar />

    <ThePageFooter />

    <ThePageFbChat />
  </VApp>
</template>

<script>
import ThePageHeader from '@/components/ThePageHeader.vue';
import TheCookieBar from '@/components/TheCookieBar.vue';
import ThePageFooter from '@/components/ThePageFooter.vue';
import ThePageFbChat from '@/components/ThePageFbChat.vue';

export default {
  name: 'App',
  components: {
    ThePageHeader,
    TheCookieBar,
    ThePageFooter,
    ThePageFbChat,
  },
};
</script>


<style>
@font-face {
  font-family: 'Autumn';
  src: url('assets/autumn-in-november.ttf') format('truetype');
}

img {
  user-select: none;
}

.router-link-active {
  color: #d1ae68 !important;
}

.theme--light.application {
  background: white;
}

.appear-enter-active,
.appear-leave-active {
  transition: opacity 0.5s;
}
.appear-enter,
.appear-leave-to {
  opacity: 0;
}

.container {
  max-width: 1920px;
  margin: auto;
  overflow: hidden;
  min-height: 100vh;
}

@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  .container {
    width: calc(100vw - 17px);
  }
}
</style>
